// extracted by mini-css-extract-plugin
export default {"launcher":"N_dQ","launcher__heading":"N_dR","launcher__menu-item":"N_dS"};